<category-component></category-component>

<div class="full-width-control d-block d-lg-none fixed-header-height-device">
    <!-- Sorting and filter for mobile and ipad -->
    <ul class="top-controls is-full-width" *ngIf="!noRecord">
        <li>
            <div class="d-lg-none d-block product-sorting">
                <div class="btn-group" dropdown>
                    <button id="button-basic" dropdownToggle type="button" class="btn  dropdown-toggle"
                        aria-controls="dropdown-basic">
                        Sort 
                    </button>
                    <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu " role="menu" aria-labelledby="button-basic">
                        <li role="menuitem"><a class="dropdown-item" (click)="productSort(1, 'rsp', 'desc')" href="javascript:void(0);">RSP: High to low</a></li>
                        <li role="menuitem"><a class="dropdown-item" (click)="productSort(2, 'rsp', 'asc')" href="javascript:void(0);">RSP: Low to high</a></li>
                        <li role="menuitem"><a class="dropdown-item" (click)="productSort(3, 'short_desc', 'asc')" href="javascript:void(0);">Ascending A-Z</a></li>
                        <li role="menuitem"><a class="dropdown-item" (click)="productSort(4, 'short_desc', 'desc')" href="javascript:void(0);">Descending Z-A</a></li>
                    </ul>
                </div>
            </div>
              <!-- Product sorting -->
        </li>
    </ul>
    <div class="quick-add-accordion common-accordion">
        <accordion [isAnimated]="true">
            <accordion-group heading="Quick Add">
                <quick-add></quick-add>
            </accordion-group>
        </accordion>
    </div>
</div>


<div  class="container-fluid product-lisitng-wrapper fixed-header-height">
    <div class="row">
        <div class="col-12 fixed-width-left-column all-product-col">
            <div class="d-none d-lg-block">
                    <quick-add></quick-add>
            </div>
        </div>
     

        <div class="col-12  fixed-width-right-column all-product-col">
            <!-- Product listing HTML markup -->
            <ul class="breadcrumbs d-flex">
                <li>
                    <a routerLink="/" title="Home">Home</a>
                </li>
                <li>
                    <span> <img src="../../assets/images/seperator-arrow.svg" alt="seperator-arrow" /> </span>
                </li>
                <li>
                   Suggested products
                </li>
            </ul>

            <div class="category-heading" >
                <h1>Suggested Products</h1>
                <div class="add-by" *ngIf="!noRecord">
                    <img *ngIf="salesRepDetail.image" src="{{profileImagePath}}{{salesRepDetail.image}}" alt="{{salesRepDetail.name}}">
                   <img *ngIf="!salesRepDetail.image" src="../../../../assets/images/profile.svg" alt="{{salesRepDetail.name}}">
                   <p>{{salesRepDetail.name}} ({{salesRepDetail.product_count}})</p>
                </div>
            </div>

            <div class="d-none d-lg-block" *ngIf="!noRecord">
                 <!-- Product sorting -->
            <div class="d-lg-block d-none">
                <div class="sorting">
                    <div class="sort-by">
                        Sort By:
                    </div>
                    <ul class="sorting-order">
                        <li> <a [ngClass]="{'active': selectedSort == 1}" href="javascript:void(0);" (click)="productSort(1, 'rsp', 'desc')" title="Rsp: High to low">RSP: High to low</a> </li>
                        <li> <a [ngClass]="{'active': selectedSort == 2}"  href="javascript:void(0);" (click)="productSort(2, 'rsp', 'asc')" title="Rsp: Low to high">RSP: Low to high</a> </li>
                        <li> <a [ngClass]="{'active': selectedSort == 3}" href="javascript:void(0);" (click)="productSort(3, 'short_desc', 'asc')" title="Ascending A-Z">Ascending A-Z</a></li>
                        <li> <a [ngClass]="{'active': selectedSort == 4}" href="javascript:void(0);" (click)="productSort(4, 'short_desc', 'desc')" title="Descending Z-A">Descending Z-A</a> </li>
                        
                    </ul>
                </div>
            </div>
              <!-- Product sorting -->
            </div>
            <div  class="product-grid of-product-listing" *ngIf="!noRecord" infiniteScroll [infiniteScrollDistance]="2"
            [infiniteScrollThrottle]="50" (scrolled)="onScrollDown()" [scrollWindow]="true">

                <div class="product-wrapper product-page-listing" id="product_{{product.sku}}" *ngFor="let product of productList">
                    <ul class="product-type" *ngIf="product.price_marked == 1">
                        <li>
                            <img
                            src="../../assets/images/pmp.svg" alt="checked icon" />
                        </li>
                    </ul>
                    <div class="product-inner-wrapper">
                        <div class="product-image">
                            <a href="javascript:void(0);">
                                <a [routerLink]="['/product/detail',product.sku]">
                                    <img src="{{imagePath}}{{product?.images[0]}}" alt="">
                                </a>
                            </a>
                        </div>
                        <div class="product-description" id="product_description_{{product.sku}}">
                            <a routerLink="/product/detail/{{product.sku}}" class="product-detail-name-bar">
                                <h2>{{product.short_desc}} </h2><p>({{product.unit_size}})</p>
                            </a>
                            <ul class="product-code">
                                <li>{{product.barcode}}</li>
                                <li class="seperator">|</li>
                                <li>{{product.sku}}</li>
                            </ul>
                            <ul class="order-quantity-details">
                                <li>
                                    <span>RSP</span>
                                    <p> <span *ngIf="product.rsp !== '0.00'">£{{product.rsp}}</span>
                                        <span *ngIf="product.rsp == '0.00'">N/A</span>  
                                        <span *ngIf="product.rsp != '0.00' && (product.sale_unit != '' && (product.sale_unit == 'Kilo' || product.sale_unit == 'Each'))">per 100g</span>
                                        <span *ngIf="product.rsp != '0.00' && (product.sale_unit != '' && product.sale_unit.indexOf('C') !== -1)">each</span>
                                    </p>
                                </li>
                                <li *ngIf="global_data?.margin_visibility == 1">
                                    <span>Margin</span>
                                    <p><span>{{product.margin}}%</span></p>
                                </li>
                                <li *ngIf="global_data?.price_visibility == 1">
                                    <span>Cost</span>
                                    <p><strong>£{{product.price}}</strong></p>
                                </li>
                                <li>
                                    <span>Case</span>
                                    <p><strong>{{product.size_case}}</strong></p>
                                </li>
                            </ul>
                            <p *ngIf="product.back_in_stock == '0'" class="product-cart-status d-flex d-md-none"> <img
                                src="../../assets/images/cross-round.svg" alt="checked icon" />Out of Stock</p>
                        <div class="add-cart-wrapper add_btn_{{product.product_id}}" ng-app="classApp"
                            [ngClass]="product.item_id !== '' ? 'expand' : 'no-expand'">
                            <div id="spinner_{{product.product_id}}">
                                <ngx-number-spinner id="spinerbtn_{{product.product_id}}" *ngIf="product.item_id != ''"
                                    [ngClass]="{'spinner':true, 'disabled':product.back_in_stock == '0' ?true : false}"
                                    [value]="toInteger(product.qty)" [min]="0" 
                                    (change)="qytChange(product, $event, commonTemplate)">
                                </ngx-number-spinner>
                            </div>
                            <div class="right-column suggested-col">
                                <button
                                [ngClass]="{'btn not-interested-btn':true}"
                                id="notinterestbtn_{{product.product_id}}" *ngIf="product.item_id == ''"
                                (click)="notInteretedSuggest(product)">Not Interested</button>
                                <button
                                [ngClass]="{'btn primary-btn':true, 'disabled':product.back_in_stock == '0' ?true : false}"
                                id="btn_{{product.product_id}}" *ngIf="product.item_id == '' && miniCartDetails.items_count != 0"
                                (click)="addToCart(product, product.qty, '', 'common', commonTemplate)">Add</button>
                                <button
                                    [ngClass]="{'btn primary-btn':true, 'disabled':product.back_in_stock == '0' ?true : false}"
                                    id="btn_{{product.product_id}}" *ngIf="product.item_id == '' && miniCartDetails.items_count == 0"
                                    (click)="addToCart(product, product.qty, addToCartTemplate, 'cart', commonTemplate)">Add</button>
                                <p *ngIf="product.back_in_stock == '0'"
                                    class="product-cart-status d-none d-md-flex"> <img
                                        src="../../assets/images/cross-round.svg" alt="checked icon" />Out of Stock
                                </p>
                            </div>
                        </div>

                        </div>
                    </div>
                </div>
            </div>

            <!-- No result found -->
            <div class="row no-result" *ngIf="contentLoaded && noRecord">
                <div class="col-12">
                    <div class="no-result-content">
                        <img src="../../assets/images/no-result.svg" alt="no-result">
                        <p>Sorry, no results found!</p>
                        <span>We couldn’t find what you’re looking for</span>
                    </div>
                </div>
            </div>

            <div class="row no-result" *ngIf="!contentLoaded && noRecord">
                <div class="col-12">
                    <div class="no-result-content">
                        <img src="../../assets/images/hourglass-shb.svg" alt="no-result">
                        <p>Loading...</p>
                    </div>
                </div>
            </div>


        </div>
    </div>
</div>

<ng-template #addToCartTemplate>
    <div class="modal-header border-0 pb-2 align-items-center flex-column">
        <h4 class="modal-title">Info</h4>
        <p>You are about to create a order for</p>
        <h4 class="modal-title">{{selectedStore.selectedStoreName}}</h4>
    </div>
    <div class="modal-body py-0 px-0">
      <div class="row">
        <div class="col-md-12">
          <div class="text-center">
            <p>Please change the store if you want to create an order for another store.</p>
          </div>
          <div class="button-success text-center mt-3">
            <button class="common-button mr-3" (click)="bsModalRef.hide()">Ok</button>
            
          </div>
        </div>
      </div>
    </div>
  </ng-template>

<ng-template #commonTemplate>
    <div class="modal-header border-0 pb-2 align-items-center">
        <h4 class="modal-title">Info</h4>
    </div>
    <div class="modal-body py-0 px-0">
      <div class="row">
        <div class="col-md-12">
          <div class="text-center">
            <p>{{popupMessage}} </p>
          </div>
          <div class="button-div text-center mt-3 align-items-center">
            <button class="common-button mr-3" (click)="bsModalRef.hide()">{{commonBottonText}}</button>
          </div>
        </div>
      </div>
    </div>
  </ng-template>